import React from 'react';
import { AuthProvider } from './Auth';
import { ToastProvider } from './Toast';
import { RouteProvider } from './Route';

const AppProvider: React.FC = ({ children }) => {
  return (

    <AuthProvider>
      <RouteProvider>
        <ToastProvider>{children}</ToastProvider>
      </RouteProvider>

    </AuthProvider>
  );
};

export default AppProvider;
